/** OA CAS browser helpers — dual-track with password login. */

const PENDING_REDIRECT_KEY = "liando.oa_redirect";
const PENDING_STATE_KEY = "liando.oa_state";

function createLoginState(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/** Absolute callback URL registered with CAS (must match backend service whitelist). */
export function getOaCallbackUrl(state = ""): string {
  if (typeof window === "undefined") return "/oa-callback";
  const url = new URL("/oa-callback", window.location.origin);
  if (state) url.searchParams.set("state", state);
  return url.toString();
}

export function rememberOaRedirect(path: string, state: string): void {
  sessionStorage.setItem(PENDING_REDIRECT_KEY, path || "/");
  sessionStorage.setItem(PENDING_STATE_KEY, state);
}

export function consumeOaRedirect(stateFromQuery: string): string {
  const expected = sessionStorage.getItem(PENDING_STATE_KEY) || "";
  const redirect = sessionStorage.getItem(PENDING_REDIRECT_KEY) || "/";
  sessionStorage.removeItem(PENDING_STATE_KEY);
  sessionStorage.removeItem(PENDING_REDIRECT_KEY);
  if (!stateFromQuery || !expected || stateFromQuery !== expected) {
    throw new Error("OA 登录状态校验失败，请重新发起登录");
  }
  // only allow same-origin relative paths
  if (!redirect.startsWith("/") || redirect.startsWith("//")) return "/";
  return redirect;
}

export function newOaState(): string {
  return createLoginState();
}
